import { Route, Routes } from 'react-router-dom';
import { ROUTER_LOGIN } from './router/router';
import LayoutLogin from './ui/web/layout-login/layout-login';

export function PageLogin() {
  return (
    <LayoutLogin>
      <Routes>
        {ROUTER_LOGIN.map((route) => (
          <Route key={route.path} path={route.path} element={route.component} />
        ))}
      </Routes>
    </LayoutLogin>
  );
}

export default PageLogin;
